import { ReactNode } from "react";
import { useAuth } from "@/contexts/AuthContext";
import AppShell from "@/components/layout/AppShell";

/**
 * Wrapper for routes that should be accessible to BOTH guests and signed-in
 * users (e.g. practice tests, games, worksheets, writing pad).
 *
 * - Signed-in users: rendered inside <AppShell> (sidebar + topbar) so the
 *   experience matches the rest of the app.
 * - Guests: rendered inside <AppShell> as well so they can still see the
 *   sidebar with feature links — auth-only items prompt sign-up on click.
 */
export default function PublicShellRoute({ children }: { children: ReactNode }) {
  const { loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4" />
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return <AppShell>{children}</AppShell>;
}
